import { IS_ACTIVE, IS_HIDDEN } from '../constants';

const MENU_DELAY = 250; // in milliseconds

const buildMenuOverlay = (): HTMLDivElement => {
    const menuOverlay: HTMLDivElement = document.createElement('div');
    const id = `menu-overlay-${Math.random().toString(36).slice(2, 11)}`;
    menuOverlay.classList.add('menu-overlay', 'menu-overlay--transparent', 'js-menu-overlay');
    menuOverlay.setAttribute('id', id);

    document.body.appendChild(menuOverlay);
    document.body.style.overflow = 'hidden';

    window.getComputedStyle(menuOverlay).getPropertyValue('opacity');

    requestAnimationFrame(() => {
        menuOverlay.classList.add('menu-overlay--visible');
    });

    return menuOverlay;
};

const closeMenuOverlay = (id: string): Promise<void> => {
    return new Promise<void>((resolve: () => void) => {
        const menuOverlay: HTMLDivElement | null = document.querySelector(`#${id}`);

        if (menuOverlay) {
            menuOverlay.classList.remove('menu-overlay--visible');

            document.body.style.overflow = '';

            const removeOverlay = (): void => {
                if (menuOverlay.parentNode) {
                    menuOverlay.parentNode.removeChild(menuOverlay);
                }
                resolve();
            };

            const fallbackTimeout = setTimeout(removeOverlay, MENU_DELAY);

            menuOverlay.addEventListener(
                'transitionend',
                () => {
                    clearTimeout(fallbackTimeout);
                    removeOverlay();
                },
                { once: true },
            );
        } else {
            resolve();
        }
    });
};

const togglePanel = (elm: HTMLDivElement) => {
    const panelOpen: HTMLAnchorElement | null = elm.querySelector('.js-panel__open');
    const panelClose: HTMLAnchorElement | null = elm.querySelector('.js-panel__close');
    const panelMini: HTMLDivElement | null = elm.querySelector('.js-panel__mini');
    const panelExpanded: HTMLDivElement | null = elm.querySelector('.js-panel__expanded');
    let menuOverlayId: string | undefined;
    let isClosing = false;

    const closePanel = async () => {
        if (isClosing) {
            return;
        }
        isClosing = true;

        panelExpanded?.classList.replace(IS_ACTIVE, IS_HIDDEN);
        panelMini?.classList.remove(IS_HIDDEN);
        if (menuOverlayId) {
            await closeMenuOverlay(menuOverlayId);
            menuOverlayId = undefined;
        }

        isClosing = false;
    };

    panelExpanded?.addEventListener('click', (e: Event) => {
        const target: EventTarget | null = e.target;

        if (target instanceof HTMLAnchorElement) {
            if (target.classList.contains('js-more')) {
                return;
            }

            closePanel();
        }
    });

    panelOpen?.addEventListener('click', (e: Event) => {
        e.preventDefault();
        if (isClosing) {
            return;
        }
        panelMini?.classList.add(IS_HIDDEN);
        panelExpanded?.classList.replace(IS_HIDDEN, IS_ACTIVE);
        const menuOverlay = buildMenuOverlay();
        menuOverlayId = menuOverlay.id;
    });

    panelClose?.addEventListener('click', (e: Event) => {
        e.preventDefault();
        closePanel();
    });

    document.addEventListener('click', (e: Event) => {
        const target: EventTarget | null = e.target;

        if (target instanceof HTMLDivElement) {
            if (target.matches('.js-menu-overlay')) {
                e.preventDefault();
                closePanel();
            }
        }
    });
};

export default togglePanel;
